import { TabularCopySink } from './tabular.copysink';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureCosmosDbDataset } from 'app/model/dataset/azure-cosmos-db.dataset';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';

@Metamodel.model({
    name: 'DocumentDbCollectionSink',
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(AzureCosmosDbDataset) }
})
export class AzureCosmosDbSink extends TabularCopySink {
    public static readonly MODEL: IModel;
    public static readonly WRITE_BEHAVIOR: IAttribute;
    public static readonly NESTING_SEPARATOR: IAttribute;
    public static readonly DISABLE_METRICS_COLLECTION: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'NESTING_SEPARATOR',
        display: stringResources.NestingSeparatorFieldLabel
    })
    public nestingSeparator?: string = '.';
    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior?: string = writeBehaviorOptionValues.insert;

    @Metamodel.attribute({
        templatable: true,
        association: 'DISABLE_METRICS_COLLECTION',
        display: stringResources.CopySinkDisableMetricsCollectionLabel
    })
    public disableMetricsCollection: boolean;
}
